import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { qualityStudioApiRef } from './api/QualityStudioApi';
import { QualityStudioClient } from './api/QualityStudioClient';

export const qualityStudioPlugin = createPlugin({
  id: 'quality-studio',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: qualityStudioApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new QualityStudioClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const QualityStudioPage = qualityStudioPlugin.provide(
  createRoutableExtension({
    name: 'QualityStudioPage',
    component: () =>
      import('./components/QualityStudioPage').then(
        m => m.QualityStudioPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
